import type { ReactElement, ReactNode } from 'react'

export interface FilterOption {
  value: string | number
  label: string
}

export interface DataField {
  name: string
  withSort?: boolean
  withFilter?: boolean
  filterOptions?: FilterOption[]
  maxWidth?: string
  /** When true, column does not truncate with ellipsis and can use available width */
  fullWidth?: boolean
  /** When true, cell content is not truncated (no ellipsis); full display */
  noTruncate?: boolean
  className?: string
  attachment?: boolean | string
  badge?: Record<string | number, string>
  badgeLabels?: Record<string | number, string>
  downloadUrl?: string
}

export interface OtherAction {
  name: string
  link?: string
  onClick?: (row: any) => void
  show?: (row: any) => boolean
  render?: (row: any, isLoading?: boolean, onClick?: () => void) => ReactNode // Custom renderer for the action
}

export interface DataTableOptions {
  showActionsColumn: boolean
  dataFields: Record<string, DataField>
  dataSource: string
  primaryKey?: string
  softDelete?: boolean
  displayInModal?: boolean
  noRecordText?: string
  otherActions?: OtherAction[]
  


  hideSelection?: boolean        // hides checkbox column
  hideActionsHeader?: boolean    // hides "Actions" label in the header
  hideActionsColumn?: boolean
  /** When true, hide the Actions column and open row actions via right-click context menu */
  useRowContextMenu?: boolean
  onRowClick?: (row: any) => void
  isRowClickable?: (row: any) => boolean
}

export interface RowActionItem {
  key: string
  label: string
  icon?: ReactElement
  color?: string
  dividerBefore?: boolean
  onClick?: () => void
  as?: React.ElementType
  to?: string
  href?: string
  target?: string
  download?: boolean
}

export function getTableColumnCount(options: DataTableOptions, hasCustomActionRenderer = false): number {
  const showActionsColumn =
    options.showActionsColumn !== false &&
    !options.useRowContextMenu &&
    !options.hideActionsColumn &&
    !hasCustomActionRenderer

  return (
    Object.keys(options.dataFields).length +
    (options.hideSelection ? 0 : 1) +
    (showActionsColumn ? 1 : 0)
  )
}

export function shouldShowActionsColumn(options: DataTableOptions, hasCustomActionRenderer = false): boolean {
  return (
    options.showActionsColumn !== false &&
    !options.useRowContextMenu &&
    !options.hideActionsColumn &&
    !hasCustomActionRenderer
  )
}

export interface Permission {
  can_edit?: boolean
  can_delete?: boolean
  can_create?: boolean
  can_view?: boolean
  can_export?: boolean
  can_import?: boolean
  [key: string]: boolean | undefined
}

export interface MetaData {
  total: number
  all?: number
  pending?: number
  acknowledged?: number
  trashed?: number
  my?: number
  unassigned?: number
  per_page: number
  current_page: number
  links: PaginationLink[]
}

export interface PaginationLink {
  url: string | null
  label: string
  active: boolean
}

export interface SortParams {
  order: string
  sort: 'asc' | 'desc'
}


